export default __webpack_public_path__ + "static/media/accessories.94231c57.webp";